export const COLLAPSE_GROUP_NAME = 'COLLAPSE_GROUP_NAME_SETTINGS';

export const CLIPBOARD_OF_SCHEMA_SETTING_IN_LOCAL_STORAGE = 'schemaSettings';
